import { useLingui } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Button from '../../../components/atoms/Button.mjs';
import Column from '../../../components/atoms/Column.mjs';
import { Confirmation } from '../../../components/molecules/Confirmation.mjs';
import { useGlobalReducer, AppScreens } from '../../GlobalContextProvider.mjs';

const Success = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const [, dispatch] = useGlobalReducer();
    return /*#__PURE__*/ React__default.createElement(Column, {
        gap: 6
    }, /*#__PURE__*/ React__default.createElement(Confirmation, {
        header: $__i18n._({
            id: "crypto.success.title"
        }),
        text: $__i18n._({
            id: "crypto.success.content"
        })
    }), /*#__PURE__*/ React__default.createElement(Button, {
        variant: "outline",
        onClick: ()=>dispatch({
                type: 'transition',
                screen: AppScreens.Main
            })
    }, $__i18n._({
        id: "button.goBack"
    })));
};

export { Success };
//# sourceMappingURL=Success.mjs.map
